import React from "react";

const Icon = (props) => {
  return <img src={props.src} height={50} width={50} />;
};

export default Icon;
